module.exports = __webpack_public_path__ + "static/media/somar.85f16945.svg";